import { Link } from "react-router-dom";
import HumanoidRobotImage from "./HumanoidRobotImage";
import { StarDisplay } from "../community/StarRating";
import { countryFlagByCode, getManufacturerById, getPrimaryPrice } from "../../data/humanoidCatalog";

function statusClass(robot) {
  if (robot.availability === "Available") return "bg-emerald-50 text-emerald-800 border-emerald-200";
  if (robot.availability === "Pre-order") return "bg-amber-50 text-amber-800 border-amber-200";
  if (robot.availability === "Contact sales") return "bg-blue-50 text-blue-800 border-blue-200";
  return "bg-neutral-100 text-neutral-700 border-neutral-200";
}

export default function HumanoidRobotCard({ robot, communityStats = null }) {
  const manufacturer = getManufacturerById(robot.manufacturerId);
  return (
    <article className="soft-card soft-card-hover flex h-full flex-col overflow-hidden">
      <Link to={`/humanoid-robots/${robot.slug}`} className="block bg-neutral-100 p-4 pb-3">
        <HumanoidRobotImage image={robot.image} />
      </Link>
      <div className="flex flex-1 flex-col p-5">
        <div className="mb-3 flex flex-wrap items-center gap-2 text-xs font-bold uppercase tracking-[0.14em] text-neutral-500">
          <span>{countryFlagByCode[robot.robotOriginCountryCode] || "🌐"}</span>
          <span>{robot.robotOriginCountry}</span>
          <span aria-hidden="true">•</span>
          <span>{robot.category}</span>
        </div>
        <h2 className="text-xl font-black tracking-tight text-neutral-950">
          <Link to={`/humanoid-robots/${robot.slug}`} className="hover:text-blue-700">
            {robot.name}
          </Link>
        </h2>
        <Link
          to={`/humanoid-robots/manufacturer/${manufacturer.slug}`}
          className="mt-1 text-sm font-semibold text-blue-700 hover:underline"
        >
          {robot.manufacturerName}
        </Link>
        <div className="mt-4 min-h-7">
          {communityStats?.reviewCount > 0 ? <StarDisplay value={communityStats.averageRating} count={communityStats.reviewCount} /> : <span className="text-sm font-semibold text-neutral-500">No community reviews yet</span>}
        </div>
        <p className="mt-3 text-2xl font-black text-neutral-950">{getPrimaryPrice(robot)}</p>
        <div className="mt-3">
          <span className={`inline-flex rounded-full border px-3 py-1 text-xs font-bold ${statusClass(robot)}`}>
            {robot.availability}
          </span>
        </div>
        <p className="mt-4 line-clamp-3 text-sm leading-6 text-neutral-600">{robot.summary}</p>
        <Link to={`/humanoid-robots/${robot.slug}`} className="btn-secondary mt-5 w-full text-center">
          View robot details
        </Link>
      </div>
    </article>
  );
}
